
<div class="cbar">
  <div class="ms-CommandBar">
    <div class="ms-CommandBar-mainArea">
      <div class="ms-CommandButton">
        <button
          (click)="abrirModalCrear()"
          class="ms-CommandButton-button"
          type="button"
        >
          <span class="ms-CommandButton-icon ms-fontColor-themePrimary"
            ><i class="ms-Icon ms-Icon--CalculatorAddition"></i
          ></span>
          <span class="ms-CommandButton-label">Nuevo</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="pageContent">
  <div class="pageTitle">
    <h2>Grupos</h2>
  </div>
  <app-data-table tableId="datatableGrupos" [serverSide]="true" [serverData]="getDataTableGrupo" [columns]="columnas" (loadedGrid)="gridLoaded($event)" (custom)="customClick($event)" [buttonsOptions]="dtOptButtons"></app-data-table>
</div>


<!-- Nuevo -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader create-grupo" appPreventOutsideClick>
    <div id="dialogCreateEdit" class="ms-Dialog-title">Crear Grupo</div>
    <form [formGroup]="groupForm" (ngSubmit)="crearEditarGrupo()" name="groupForm">
      <div class="ms-Dialog-content">
        <div>
          <app-text-box [frm]="groupForm" formControlName="NombreGrupo" type="text" [required]="true" label="Grupo"></app-text-box>
        </div>
        <div>
          <app-text-area [frm]="groupForm" formControlName="Descripcion" [required]="true" label="Descripción" rows="3"></app-text-area>
        </div>
        <app-check-box [frm]="groupForm" formControlName="Activo" label="Activo"></app-check-box>
      </div>
      <app-form-buttons 
        [botonProcesando]="botonProcesando"
        buttonCancelId="btnCancel"
        labelCancel="Cancelar"
        buttonSaveId="btnCreateEdit"
        labelSave="Crear"
        [labelLoading]="textoBotonProcesando" 
        [frm]="groupForm"
        (cancel)="clearFormGrupo()"
        [validate]="true">
      </app-form-buttons>
      <!-- <div class="ms-Dialog-actions" [hidden]="botonProcesando">
        <button
          type="button"
          class="ms-Button ms-Dialog-action"
          (click)="clearForm()"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="ms-Button ms-Button--primary"
          [disabled]="groupForm.invalid">
            <span id="btnCreateEdit" class="ms-Button-label">Crear</span>
        </button>
      </div> -->
    </form>

    <!-- <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{ textoBotonProcesando }}
      </div>
    </div> -->
  </div>

  <!-- <table
    datatable
    [dtOptions]="dtOptions"
    class="ms-Table ms-Table--selectable order-column row-border"
    style="width: 100%"
    id="datatableGrupos"
  ></table> -->
</div>

<!-- Usuarios Permitidos -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader usuario-permitido" appPreventOutsideClick>
    <div class="ms-Dialog-title">Usuarios Permitidos</div>

    <table
      datatable
      [dtOptions]="dtOptionsUsuariosPermitidos"
      class="ms-Table ms-Table--selectable order-column row-border"
      style="width: 100%"
      id="datatableUsuariosPermitidos"
    ></table>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>

      <button type="button" class="ms-Button ms-Button--primary">
        <span class="ms-Button-label"
          >Editar <i class="ms-Icon ms-Icon--Add"></i
        ></span>
      </button>
    </div>
    <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{ textoBotonProcesando }}
      </div>
    </div>
  </div>
</div>
<!-- Fin Usuarios Permitidos -->

<!-- Añadir Usuarios -->
<div class="docs-DialogExample-lgHeader">
  <div class="ms-Dialog ms-Dialog--lgHeader añadir-usuario">
    <div class="ms-Dialog-title">Añadir Usuario</div>

    <table
      datatable
      [dtOptions]="dtOptionsAddUsuarios"
      class="ms-Table ms-Table--selectable order-column row-border"
      style="width: 100%"
      id="dataTableAddUsuarios"
    ></table>
    <div class="ms-Dialog-actions" [hidden]="botonProcesando">
      <button type="button" class="ms-Button ms-Dialog-action">Cancelar</button>
    </div>
    <div class="ms-Spinner" [hidden]="!botonProcesando">
      <div class="ms-Spinner-label">
        {{ textoBotonProcesando }}
      </div>
    </div>
  </div>
</div>
<!-- Fin Añadir Usuarios -->

<app-modal-notify #crearModal></app-modal-notify>
